module.exports = __webpack_public_path__ + "static/img/renzhenglianmeng.4c9faf7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/commons/footer/renzhenglianmeng.png
// module id = feRo
// module chunks = 1 3 4 5 6 7